import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import { Icon } from 'legacy-packages/ft-cb';
import PracticeSkillsContainer from 'chameleon-packages/units/components/PracticeSkills/PracticeSkillsContainer';
import PopOver from 'chameleon/ui-stack/ui/base/popover';
import { setMathJaxTypeset } from 'chameleon-src/utility/utils';

import './RelatedItem.scss';
import uniqid from 'uniqid';

const ChildItem = ({ child }) => {
  if (child.label.match(/Skill|Practice/)) {
    return (
      <div className="PracticeSkill--box--ResultDetail">
        <PracticeSkillsContainer
          skills={[
            {
              category: child.category,
              label: child.label.replace('Skill ', '').replace('Practice ', ''),
              name: child.description,
            },
          ]}
          ariaDescribedBy={[uniqid()]}
        />
      </div>
    );
  }
  return (
    <span className="child-link">
      <span className="child-title">{child.label}</span>
    </span>
  );
};

const RelatedItem = (props) => {
  const {
    item: { title, children },
    data,
    showPracticeQuestions,
    subjectId,
  } = props;

  const popOverContent = (
    <div className="popover-content">
      {data.map((category, key) => (
        <div className="popover-category" key={key}>
          {category.children.map((child) => {
            let { description, title, label } = child;
            if (!description || description === title) {
              return (
                <div key={title}>
                  <p>{description || title}</p>
                </div>
              );
            }
            description = description.substring(description.indexOf(':') + 1);
            return (
              <div key={title}>
                <p>
                  {label}: {description}
                </p>
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );

  return (
    <li className="related-item">
      <span className="title">{title}</span>
      {children.map((child, key) => {
        const popOverContentId = `related-content-and-skills-popover-${uniqid()}`;

        let practiceQuestionsLink;
        if (showPracticeQuestions) {
          practiceQuestionsLink = {
            pathname: `/${subjectId}/question_bank/questions/filters`,
            state: {
              tagId: child.tagId,
              questionBankPath: '/questions',
            },
          };
        }
        return (
          <span className="related-item-body" key={key}>
            <PopOver
              size="medium"
              accessibility={{
                'aria-describedby': popOverContentId,
                role: 'button',
              }}
              onContentMount={(contentElementRef) =>
                setMathJaxTypeset(contentElementRef.current)
              }
              trigger={<ChildItem child={child} />}
            >
              <div id={popOverContentId}>{popOverContent}</div>
            </PopOver>
            {practiceQuestionsLink && (
              <span className="related-item-practice-questions">
                <Link to={practiceQuestionsLink} title="Practice Questions">
                  <span className="resource-icon" key="icon">
                    <Icon name="practice-question" width="14" height="14" />
                  </span>
                  <span>AP Questions</span>
                </Link>
              </span>
            )}
          </span>
        );
      })}
    </li>
  );
};

RelatedItem.displayName = 'RelatedItem';

RelatedItem.propTypes = {
  item: PropTypes.shape({
    title: PropTypes.string,
    children: PropTypes.array,
  }).isRequired,
};

export default RelatedItem;
